import { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function Sidebar() {
  const { user, logout, ehFornecedor, ehInterno } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  // Fecha o drawer ao navegar
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Fecha ao girar / redimensionar
  useEffect(() => {
    const fechar = () => setMobileOpen(false);
    window.addEventListener('orientationchange', fechar);
    window.addEventListener('resize', fechar);
    return () => {
      window.removeEventListener('orientationchange', fechar);
      window.removeEventListener('resize', fechar);
    };
  }, []);

  // Trava o scroll do body enquanto o drawer está aberto
  useEffect(() => {
    if (mobileOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [mobileOpen]);

  const sair = () => { logout(); navigate('/login'); };

  return (
    <>
      {/* Header mobile com hamburger */}
      <div className="mobile-header">
        <button onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}>
          <i className={`bi ${mobileOpen ? 'bi-x-lg' : 'bi-list'}`} />
        </button>
        <img src={logo} alt="Centrão" className="sidebar-logo" />
        <div className="sidebar-title">Portal de Fornecedores<span>Centrão</span></div>
      </div>

      {/* Overlay escuro */}
      <div className={`sidebar-overlay ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(false)} />

      {/* Sidebar — rail (colapsada por padrão, expande no hover; drawer no mobile) */}
      <nav className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="Centrão" className="sidebar-logo" />
          <div className="sidebar-title sidebar-label">Portal de Fornecedores<span>Centrão Materiais</span></div>
        </div>

        <div className="sidebar-nav">
          {ehFornecedor && (
            <>
              <div className="sidebar-section sidebar-label">Meus dados</div>
              <NavLink to="/meu-mix" title="Meu Mix"><i className="bi bi-grid" /><span className="nav-label sidebar-label">Meu Mix</span></NavLink>
              <NavLink to="/vendas" title="Vendas"><i className="bi bi-graph-up" /><span className="nav-label sidebar-label">Vendas</span></NavLink>
              <NavLink to="/pedidos" title="Pedidos de compra"><i className="bi bi-truck" /><span className="nav-label sidebar-label">Pedidos</span></NavLink>
              <NavLink to="/cotacoes" title="Cotações pedidas pelo Centrão"><i className="bi bi-clipboard-check" /><span className="nav-label sidebar-label">Cotações</span></NavLink>
            </>
          )}

          {ehInterno && (
            <>
              <div className="sidebar-section sidebar-label">Administração</div>
              <NavLink to="/admin/fornecedores" title="Fornecedores"><i className="bi bi-building" /><span className="nav-label sidebar-label">Fornecedores</span></NavLink>
              <NavLink to="/admin/ajuda" title="Ajuda — como funciona"><i className="bi bi-question-circle" /><span className="nav-label sidebar-label">Ajuda</span></NavLink>
            </>
          )}
        </div>

        {/* Bloco inferior: usuário + ações */}
        <div className="sidebar-bottom">
          <div className="sidebar-user-info sidebar-label">
            <i className="bi bi-person-circle me-2" />{user?.nome}
            <div className="sidebar-user-grupo">{ehFornecedor ? (user?.fornecedor_nome || 'Fornecedor') : 'Administrador'}</div>
          </div>
          <div className="sidebar-acoes-row">
            <NavLink to="/meu-perfil" className="sidebar-acao-btn" title="Meu Perfil">
              <i className="bi bi-gear" /><span className="sidebar-label">Perfil</span>
            </NavLink>
            <button className="sidebar-acao-btn" onClick={sair} title="Sair">
              <i className="bi bi-box-arrow-left" /><span className="sidebar-label">Sair</span>
            </button>
          </div>
        </div>

        <div className="sidebar-footer sidebar-label">Centrão Materiais de Construção</div>
      </nav>
    </>
  );
}
